import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Box,
  Slider,
  Typography,
  Button,
} from "@mui/material";
import { format, isToday } from "date-fns";

const DateTimePicker = (props) => {
  const {item} = props
  const now = new Date();
  const initialDate = new Date();
  if (item?.text_data?.date1?.from_day > 0) {
    initialDate.setDate(initialDate.getDate() + item.text_data.date1.from_day);
  }
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [hour, setHour] = useState(now.getHours());
  const [disabled, setDisabled] = useState(false);
  const year2000 = new Date(2000, 0, 1);

  // Calculate min and max dates based on whether date1 exists
  const minSelectableDate = item?.text_data?.date1 
    ? (() => {
        const date = new Date();
        date.setDate(now.getDate() + (item?.text_data?.date1.from_day || 0));
        return date > year2000 ? date : year2000;
      })()
    : year2000; 

  const maxSelectableDate = item?.text_data?.date1 
    ? (() => {
        const date = new Date();
        date.setDate(now.getDate() + (item?.text_data?.date1.to_day || 60));
        return date;
      })()
    : new Date(); // No restriction if date1 doesn't exist

  const isSelectedToday = isToday(selectedDate);

  const updateErrors = (newDate) => {
    const formatted = format(newDate, "MM/dd/yyyy HH:00:00");
    props?.setErrors?.((prevErrors) => ({
      ...prevErrors,
      [props?.index]: { key1: formatted, displayName: formatted },
    }));
  };

  const handleDateChange = (date) => {
    const updatedDate = new Date(date);
    updatedDate.setHours(hour);
    updatedDate.setMinutes(0);
    setSelectedDate(updatedDate);
    updateErrors(updatedDate);
  };
  
  const handleHourChange = (_, newHour) => {
    if (disabled) return;
    const now = new Date();
    if (isSelectedToday && newHour < now.getHours()) return;
  
    const newDate = new Date(selectedDate);
    newDate.setHours(newHour);
    newDate.setMinutes(0);
    setHour(newHour);
    setSelectedDate(newDate);
    updateErrors(newDate);
  };
  
  // const handleMinuteChange = (_, newMinute) => {
  //   if (disabled) return;
  //   const now = new Date();
  //   if (isSelectedToday && hour === now.getHours() && newMinute < now.getMinutes()) return;
  
  //   const newDate = new Date(selectedDate);
  //   newDate.setMinutes(newMinute);
  //   setMinute(newMinute);
  //   setSelectedDate(newDate);
  //   updateErrors(newDate);
  // };

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#fdfdfd",
        borderRadius: 3,
        boxShadow: 3,
        maxWidth: 700,
        mx: "auto",
        marginBottom: "20px",
      }}
    >
     <Typography
      gutterBottom
      sx={{ fontSize: '14px', fontWeight: 500 , marginBottom :'30px' }}
      dangerouslySetInnerHTML={{ __html: item?.text || "Select Date and Time" }}
    />

      <Box display="flex" alignItems="center" gap={3} flexWrap="wrap">
        {/* Date Picker */}
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          minDate={minSelectableDate}
          maxDate={maxSelectableDate}
          disabled={disabled}
          customInput={
            <Button
              variant="outlined"
              sx={{
                px: 2,
                py: 1,
                fontWeight: 500,
                textTransform: "none",
                borderRadius: 2,
                backgroundColor: "#fff",
              }}
              disabled={disabled}
              className="custom-datepicker-button"
            >
              {format(selectedDate, "dd MMM yyyy")}
            </Button>
          }
        />

        {/* Time Display */}
        <Typography>{format(selectedDate, "HH:00:00")}</Typography>

        {/* Hour Slider */}
        <Box width={150}>
          <Typography variant="body2" gutterBottom>Hour</Typography>
          <Slider
            value={hour}
            onChange={handleHourChange}
            min={isSelectedToday ? now.getHours() : 0}
            max={23}
            step={1}
            valueLabelDisplay="auto"
            disabled={disabled}
            className="custom-minute-slider"
          />
        </Box>

        {/* Minute Slider */}
        {/* <Box width={150}>
          <Typography variant="body2" gutterBottom>Minute</Typography>
          <Slider
            value={minute}
            onChange={handleMinuteChange}
            min={isSelectedToday && hour === now.getHours() ? now.getMinutes() : 0}
            max={59}
            step={1}
            valueLabelDisplay="auto"
            disabled={disabled}
            className="custom-minute-slider"
          />
        </Box> */}
      </Box>
    </Box>
  );
};

export default DateTimePicker;